import React, { useEffect, useState } from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import MHSearchField from '../mhSearchField';
import Medicard from '../mediCard';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { appConfig } from "../../../common/constants";
function Procedures(props) {
  console.log(props,"procedure")
  const [data, setData] = useState([])
  let [progress, setProgress] = useState(false);
  useEffect(() => {
    setProgress(true);
    var url
    if (props.app !== "Patient") {
      if(props.data?.patient360==="Y"){
        url = `${appConfig.BaseUrl}patientdetail?patientId=${props.data.ehrPatientId}&eventType=Procedure&from=0&size=${props.formValues.headerData["Procedure"]}&combinedFlag=Y`
      }else if (props.data.patientId != "" || props.data.patientId != null || props.data.patientId != undefined) {
        url = `${appConfig.BaseUrl}patientdetail?hekmaMail=${props.data.email}&patientId=${props.data.subjectId}&eventType=Procedure&from=0&size=${props.formValues.headerData["Procedure"]}&combinedFlag=Y`
      } else {
        url = `${appConfig.BaseUrl}patientdetail?patientId=${props.data.subjectId}&eventType=Procedure&from=0&size=${props.formValues.headerData["Procedure"]}&combinedFlag=Y`
      }

    } else {
      url = `${appConfig.BaseUrl}patientdetail?hekmaMail=${props.data.email}&eventType=Procedure&from=0&size=${props.formValues.headerData["Procedure"]}&patientId=${props.data.subjectId}&combinedFlag=Y`
    }
    fetch(url,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
      .then(res => {
        if (res.status !== 200 && res.status !== 201) {
          throw new Error('Failed!');
        }
        return res.json();
      })
      .then(responseData => {

        setProgress(false);
        if (responseData.data) {
          var finaldata = []
          var objActive = []
          var objRest = []
          responseData.data.map((subitem, i) => {
            var obj = {
              title:subitem.Name,
              performedDate:moment(subitem.date_of_procedure).format('MMM Do YYYY'),
              status: subitem.Status
            }
            if (obj.status === "active") {
              objActive.push(obj)
            } else {
              objRest.push(obj)
            }
            finaldata = [...objActive, ...objRest]
          })
          setData(finaldata)
        } else {
          //console.log('no data found')
        }
      })
  }, [])
  return (
    <>
      {progress && <div className="fullScreen">
        <CircularProgress
          disableShrink
          className="progressCircle"
          value={90}
          size={100}
          thickness={1.5}
        />
      </div>}
      {
        data.length > 0 ? <>
          <section>
            <MHSearchField
              title={props.langData?.length > 0 ? props.langData.find(item => item.keyword === "procedure_lbl")?.[props.lang] : ''}
            />
          </section>

          <section className="row">
            {data.map((item, i) => (
              <div className="col-12 col-sm-4">
                <Medicard
                  instruction={item.instruction}
                  title={item.title}
                  sd={item.performedDate}
                  sdTitle={props.langData?.length > 0 ? props.langData.find(item => item.keyword === "procedure_performed_date_lbl")?.[props.lang] : ''}
                  // ed={item.endDate}
                  status={item.status}
                />
              </div>
            ))}

          </section>
        </>
          : props.langData?.length > 0 ? props.langData.find(item => item.keyword === "procedure_no_procedure_found_lbl")?.[props.lang] : ''
      }
    </>
  )

}
const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    langData: state.langData,
    lang: state.lang,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(Procedures));






